import React, { useState, useRef, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { FaCheckCircle } from "react-icons/fa";
import { RxChevronDown, RxChevronUp } from "react-icons/rx";
import LearningComponentBot from "../learning/LearningComponentBot";
import { formatCurrency } from "../../utils";
import moment from "moment";
import SkeletonCard from "../skeletons/SkeletonCard";
import BotLogo from "../commons/BotLogo";

const pieData = [
  { name: "BTC", value: 0.005103, inUSDT: 45, color: "#FFA041" },
  { name: "USDT", value: 500, inUSDT: 55, color: "#FF7556" },
];

const BotOverviewDCA = ({
  selectedBot,
  loading,
  setOpenDialog,
  handleOpenEdit,
}) => {
  // const netProfit =
  //   (selectedBot?.realized_pnl || 0) + (selectedBot?.unrealized_pnl || 0);

  // // This ROI calculation is now guaranteed to be consistent with the P/L figures.
  // const roi =
  //   selectedBot?.capital > 0 ? (netProfit / selectedBot?.capital) * 100 : 0;

  // // These percentage calculations remain correct.
  // const realizedPercentage =
  //   selectedBot?.capital > 0
  //     ? (selectedBot?.realized_pnl / selectedBot?.capital) * 100
  //     : 0;

  // const unrealizedPercentage =
  //   selectedBot?.capital > 0
  //     ? (selectedBot?.unrealized_pnl / selectedBot?.capital) * 100
  //     : 0;

  // 3
  // Get capital and current value safely
  const capital = selectedBot?.capital || 0;
  const currentValue = selectedBot?.current_balance || 0;

  // Calculate net ROI using backend-provided current value
  const netProfit = currentValue - capital;
  const roi = capital > 0 ? (netProfit / capital) * 100 : 0;

  // Realized and unrealized P/L remain displayed separately
  const realizedPnL = selectedBot?.realized_pnl || 0;
  const unrealizedPnL = selectedBot?.unrealized_pnl || 0;

  // Calculate percentage contributions
  const realizedPercentage = capital > 0 ? (realizedPnL / capital) * 100 : 0;
  const unrealizedPercentage =
    capital > 0 ? (unrealizedPnL / capital) * 100 : 0;

  const start = moment(selectedBot?.created_at);

  // console.log("selectedBot", selectedBot);

  // Format date like "21 Nov 2024, 19:20 (UTC+8)"
  const formattedDate =
    start.format("DD MMM YYYY, HH:mm") + ` (${start.format("z") || "UTC"})`;

  // Calculate duration from start until now
  const now = moment();
  const duration = moment.duration(now.diff(start)); // difference between now and start

  const days = Math.floor(duration.asDays()); // full days active
  const hours = duration.hours();

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const baseCurrency = selectedBot?.coin_name?.split("/")[1] || "USDT";

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="flex flex-col gap-5">
      {/* <div className="p-4 bg-[#D3C4FF]/10 text-[#1F2937] text-sm rounded-xl"> */}
      <div className="p-4 bg-[linear-gradient(234deg,rgba(256,256,256,1)_66.84%,#8962FF_254.21%)] text-[#1F2937] text-sm rounded-xl">
        <div className="flex flex-col gap-4 w-full">
          {/* Left Panel */}
          <div className="">
            <div className="space-y-4">
              <div className="flex items-center gap-2 w-full">
                <div className="relative flex items-center -space-x-2">
                  {!!selectedBot?.exchange_name ? (
                    <img
                      src={`/images/icons/icon_wallet_${selectedBot?.exchange_name?.toLowerCase().replace(/[\s.]+/g, "_")}.svg`}
                      alt={selectedBot?.exchange_name}
                      className="w-5 h-5 rounded-full relative top-0 right-0 flex-shrink-0"
                    />
                  ) : (
                    <div className="w-5 h-5 rounded-full relative top-0 right-0 flex-shrink-0 bg-slate-200" />
                  )}

                  <BotLogo
                    className="w-6 h-6 rounded-full flex-shrink-0"
                    classNameLogo="!h-[unset]"
                    botName={selectedBot?.strategy_name}
                  />
                </div>

                <p className="text-[#999999] leading-[1.5] text-sm md:text-[16px] capitalize flex">
                  Bot {selectedBot?.bot_status} since {formattedDate} ({days}d{" "}
                  {hours}h)
                  <span className="hidden md:block pl-2">
                    {selectedBot?.bot_status} {selectedBot?.coin_name}{" "}
                    {selectedBot?.strategy_name} {selectedBot?.exchange_name}
                  </span>
                </p>

                {/* ELIPSIS VERTICAL */}
                {/* Ikon Elipsis mepet kanan */}
                {/* <svg
                  onClick={() => setOpen((prev) => !prev)}
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-5 h-5 cursor-pointer ml-auto"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v.01M12 12v.01M12 18v.01"
                  />
                </svg> */}

                {/* Modal */}
                {/* {open && (
                  <div
                    ref={dropdownRef}
                    className="absolute w-52 right-5 top-8 rounded-lg shadow-lg bg-white  z-10"
                  >
                    <ul className="text-sm text-gray-700 p-2">
                      <li>
                        <button className="w-full text-left bg-white hover:bg-gray-100 font-medium text-black">
                          View Trade History
                        </button>
                      </li>
                      <li>
                        <button className="w-full text-left bg-white hover:bg-gray-100 font-medium text-black">
                          View Bot Log
                        </button>
                      </li>
                    </ul>
                  </div>
                )} */}
              </div>
              <div
                className="p-4 bg-[#fff] text-[#1F2937] text-sm rounded-xl "
                style={{ border: "1px solid #dde1e6" }}
              >
                <p className="font-bold text-xl">Investment</p>
                <div className="flex flex-col md:flex-row mt-3 md:mt-1">
                  <div className="md:w-1/2">
                    <p className="text-sm leading-none text-[#999999]">
                      Starting Value
                    </p>
                    <p className="flex items-center gap-2 font-bold [18px]  leading-none">
                      {loading ? (
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["40px"]}
                          heights={["10px"]}
                        />
                      ) : (
                        formatCurrency(selectedBot?.capital || 0)
                      )}{" "}
                      {baseCurrency}
                    </p>
                  </div>
                  <div className="md:w-1/2">
                    <p className="text-xs leading-none">Current Value</p>
                    <p className="flex items-center gap-2 font-bold text-[18px] leading-none !text-[#007A78]">
                      {loading ? (
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["40px"]}
                          heights={["10px"]}
                        />
                      ) : (
                        formatCurrency(selectedBot?.current_balance || 0)
                      )}{" "}
                      {baseCurrency}
                    </p>
                  </div>
                </div>

                {/* ROI */}
                <div className="flex flex-col md:flex-row md:items-center md:gap-2 mt-3 md:mt-1">
                  <p className="font-semibold text-2xl my-0">ROI</p>
                  <div className="flex flex-col min-[300px]:flex-row min-[300px]:items-center gap-3">
                    <p className="flex items-center gap-2 font-bold text-2xl my-0">
                      {loading ? (
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["60px"]}
                          heights={["10px"]}
                        />
                      ) : (
                        <>
                          {netProfit >= 0 ? "+" : ""}
                          {formatCurrency(netProfit || 0)}
                        </>
                      )}{" "}
                      {baseCurrency}
                    </p>
                    {!loading && (
                      <div className="md:text-right">
                        <span
                          className={`px-2 py-1 text-[14px] border ${
                            roi >= 0
                              ? "bg-green-500/10 !text-green-500 !border-green-500 "
                              : "bg-red-500/10 !text-red-500 !border-redn-500"
                          } rounded-md text-center whitespace-nowrap w-fit`}
                        >
                          {roi >= 0 ? "+" : ""}({formatCurrency(roi || 0)}%)
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Realized & Unrealized */}
                <div className="flex flex-col md:flex-row justify-between text-sm mt-3 md:mt-1">
                  {/* Realized */}
                  <div className="w-full md:w-1/2">
                    <p className="text-sm text-[#999999] leading-none">
                      Realized P/L
                    </p>
                    <p className="font-medium text-[18px] text-gray-800 leading-none">
                      {loading ? (
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["40px"]}
                          heights={["8px"]}
                        />
                      ) : (
                        <>
                          {selectedBot?.realized_pnl >= 0 ? "+" : ""}
                          {formatCurrency(selectedBot?.realized_pnl || 0)}{" "}
                          {baseCurrency}
                        </>
                      )}
                    </p>
                    {!loading && (
                      <p
                        className={`text-sm ${
                          realizedPercentage >= 0
                            ? "text-green-600"
                            : "text-red-600"
                        }  font-medium leading-none`}
                      >
                        {realizedPercentage >= 0 ? "+" : ""}
                        {formatCurrency(realizedPercentage || 0)}%
                      </p>
                    )}
                  </div>

                  {/* Unrealized */}
                  <div className="w-full md:w-1/2">
                    <p className="text-sm text-[#999999] leading-none">
                      Unrealized P/L
                    </p>
                    <p className="font-medium text-[18px] text-gray-800 leading-none">
                      {loading ? (
                        <div className="w-full flex items-end justify-end">
                          <SkeletonCard
                            type="text"
                            lines={1}
                            widths={["40px"]}
                            heights={["8px"]}
                          />
                        </div>
                      ) : (
                        <>
                          {selectedBot?.unrealized_pnl >= 0 ? "+" : ""}
                          {formatCurrency(
                            selectedBot?.unrealized_pnl || 0,
                          )}{" "}
                          {baseCurrency}
                        </>
                      )}
                    </p>
                    {!loading && (
                      <p
                        className={`text-sm ${
                          unrealizedPercentage >= 0
                            ? "text-green-600"
                            : "text-red-600"
                        }  font-medium leading-none`}
                      >
                        {unrealizedPercentage >= 0 ? "+" : ""}
                        {formatCurrency(unrealizedPercentage || 0)}%
                      </p>
                    )}
                  </div>
                </div>

                {/*  */}
                {/* CRYPTO WIN RATE SECTION */}
                <div className="mt-4 flex flex-col md:flex-row md:items-center justify-between p-3 rounded-xl border border-[#dde1e6] bg-[#f8f9fa]">
                  <div className="flex flex-col min-[300px]:flex-row max-md:items-start  items-center gap-3">
                    {/* Icon Container */}
                    <div className="w-10 h-10 flex-shrink-0 rounded-lg bg-indigo-50 flex items-center justify-center text-indigo-600">
                      <BotLogo
                        className="w-6 h-6 rounded-full"
                        classNameLogo="!h-[unset]"
                        botName={selectedBot?.strategy_name}
                      />
                    </div>
                    <div>
                      <p className="text-[12px] font-bold text-[#999999] uppercase tracking-wider leading-none mb-1">
                        Bot Accuracy
                      </p>
                      <p className="text-sm text-[#1F2937] font-medium leading-[1.5]">
                        Win Rate Performance
                      </p>

                      <div className="md:hidden">
                        {loading ? (
                          <SkeletonCard
                            type="text"
                            lines={1}
                            widths={["50px"]}
                            heights={["20px"]}
                          />
                        ) : (
                          <span
                            className={`px-3 py-1 rounded-full font-bold text-lg ${
                              selectedBot?.winrate == null ||
                              selectedBot.winrate < 1
                                ? "bg-gray-100 text-gray-400"
                                : selectedBot.winrate >= 50
                                  ? "bg-green-100 text-green-700"
                                  : "bg-red-100 text-red-700"
                            }`}
                          >
                            {selectedBot?.winrate == null ||
                            selectedBot.winrate < 1
                              ? "-"
                              : `${selectedBot.winrate}%`}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="max-md:hidden md:text-right">
                    {loading ? (
                      <SkeletonCard
                        type="text"
                        lines={1}
                        widths={["50px"]}
                        heights={["20px"]}
                      />
                    ) : (
                      <span
                        className={`px-3 py-1 rounded-full font-bold text-lg ${
                          selectedBot?.winrate == null ||
                          selectedBot.winrate < 1
                            ? "bg-gray-100 text-gray-400"
                            : selectedBot.winrate >= 50
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                        }`}
                      >
                        {selectedBot?.winrate == null || selectedBot.winrate < 1
                          ? "-"
                          : `${selectedBot.winrate}%`}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {!loading && (
                <div className="flex flex-col min-[320px]:flex-row gap-2 mt-4 justify-end">
                  <a
                    className="bg-transparent hover:bg-[#374151] hover:text-white ring-1 ring-black text-black px-5 py-2 text-center rounded-lg cursor-pointer"
                    onClick={handleOpenEdit}
                  >
                    Edit Settings
                  </a>
                  <a
                    className="bg-[#FF3B30] hover:bg-red-700 text-white px-5 py-2 text-center rounded-lg cursor-pointer"
                    onClick={() => setOpenDialog("stop-bot")}
                  >
                    Stop Bot
                  </a>
                  {/* {selectedBot?.bot_status === "inactive" ? (
                    <a
                      className="bg-[#007A78] hidden hover:bg-[#007A78]/90 text-white px-5 py-2 text-center rounded-lg cursor-pointer"
                      onClick={() => setOpenDialog("start-bot")}
                    >
                      Start Bot
                    </a>
                  ) : (
                    <a
                      className="bg-[#FF3B30] hover:bg-red-700 text-white px-5 py-2 text-center rounded-lg cursor-pointer"
                      onClick={() => setOpenDialog("stop-bot")}
                    >
                      Stop Bot
                    </a>
                  )} */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div className="bg-white rounded-xl p-4">
          {/* <p className="font-bold text-base mb-4">Allocation Asset</p> */}
          <div className="flex flex-col md:flex-row items-center  ">
            <div className="flex flex-col gap-1 w-full">
              <p className="font-bold text-lg mb-2">Allocation Asset</p>

              {loading
                ? pieData.map((entry, index) => (
                    <div
                      key={index}
                      className="flex items-center rounded-md gap-2"
                    >
                      <span
                        className="w-1.5 h-6 rounded-md"
                        style={{ backgroundColor: entry.color }}
                      />
                      <p className="text-sm text-gray-900">
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["60px"]}
                          heights={["10px"]}
                        />
                      </p>
                      <p className="text-sm text-gray-500 text-left">
                        <SkeletonCard
                          type="text"
                          lines={1}
                          widths={["60px"]}
                          heights={["10px"]}
                        />
                      </p>
                    </div>
                  ))
                : !!selectedBot?.assets?.chart?.length
                  ? selectedBot?.assets?.chart?.map((entry, index) => (
                      <div
                        key={index}
                        className="flex items-center rounded-md gap-2"
                      >
                        <span
                          className="w-1.5 h-6 rounded-md"
                          style={{ backgroundColor: pieData[index]?.color }}
                        />
                        <p className="text-base text-[#808080]/55">
                          {entry.label}
                        </p>
                        <p className="font-semibold text-base text-[#007A78] text-left">
                          {formatCurrency(selectedBot?.assets?.[entry.label])}{" "}
                          {entry.label}
                        </p>
                      </div>
                    ))
                  : null}
            </div>

            {/* Pie Chart */}
            <div className="relative h-[220px] w-[220px]">
              <PieChart width={220} height={220}>
                <Pie
                  data={
                    selectedBot?.assets?.chart?.length
                      ? selectedBot?.assets?.chart
                      : []
                  }
                  dataKey="value"
                  outerRadius={80}
                  innerRadius={55}
                  paddingAngle={2}
                  startAngle={90}
                  endAngle={-270}
                >
                  {selectedBot?.assets?.chart?.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={pieData[index]?.color} />
                  ))}
                </Pie>
              </PieChart>
              {/* Center Label */}
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                <p className="text-xs text-gray-500">Asset</p>
                <p className="font-bold text-lg">
                  {formatCurrency(selectedBot?.assets?.total || 0)}
                </p>
                <p className="text-xs font-semibold text-gray-700">
                  {baseCurrency}
                </p>
              </div>
            </div>

            {/* Value Boxes */}
          </div>
          <div
            className="bg-white rounded-xl p-4"
            style={{ border: "1px solid #dde1e6" }}
          >
            <div className="grid grid-cols-1 [@media(min-width:400px)]:grid-cols-2 xl:!grid-cols-4 text-left text-sm text-gray-900">
              {/* Row 1 */}
              <div className="flex flex-col pt-1">
                <p className="text-[14px] text-[#999999] leading-[12px]">
                  Capital
                </p>
                <p className="text-[18px] leading-[12px] text-[#21272A]">
                  {loading ? (
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["60px"]}
                      heights={["10px"]}
                    />
                  ) : (
                    formatCurrency(selectedBot?.setting?.capital || 0)
                  )}
                  &nbsp;{baseCurrency}
                </p>
              </div>
              <div className="flex flex-col pt-1">
                <p className="text-[14px] text-[#999999] leading-[12px]">
                  Trade size
                </p>
                <p className="text-[18px] leading-[12px] text-[#21272A]">
                  {loading ? (
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["60px"]}
                      heights={["10px"]}
                    />
                  ) : (
                    formatCurrency(selectedBot?.setting?.amount || 0)
                  )}
                  &nbsp;{baseCurrency}
                </p>
              </div>

              <div className="flex flex-col pt-1">
                <p className="text-[14px] text-[#999999] leading-[12px]">
                  Price change
                </p>
                <p className="text-[18px] leading-[12px] text-[#21272A]">
                  {loading ? (
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["60px"]}
                      heights={["10px"]}
                    />
                  ) : (
                    formatCurrency(
                      selectedBot?.setting?.price_change_percentage || 0,
                    )
                  )}
                  &nbsp;%
                </p>
              </div>
              <div className="flex flex-col pt-1">
                <p className="text-[14px] text-[#999999] leading-[12px]">
                  Take Profit
                </p>
                <p className="text-[18px] leading-[12px] text-[#21272A]">
                  {loading ? (
                    <SkeletonCard
                      type="text"
                      lines={1}
                      widths={["60px"]}
                      heights={["10px"]}
                    />
                  ) : (
                    formatCurrency(
                      selectedBot?.setting?.take_profit_percentage || 0,
                    )
                  )}
                  &nbsp;%
                </p>
              </div>

              {/* Row 2 */}

              <div className="flex flex-col pt-1">
                <p className="text-[14px] text-[#999999] leading-[3px]">
                  Trigger price
                  <strong className="!font-semibold text-black text-sm leading-[3px] ml-1">
                    {loading ? (
                      <SkeletonCard
                        type="text"
                        lines={1}
                        widths={["60px"]}
                        heights={["10px"]}
                      />
                    ) : (
                      formatCurrency(selectedBot?.setting?.trigger_price || 0)
                    )}
                    &nbsp;{baseCurrency}
                  </strong>
                </p>
              </div>
              <div className="flex flex-col pt-1">
                <p className="text-[14px] text-[#999999] leading-[3px]">
                  Max. orders
                  <strong className="!font-semibold text-black text-sm leading-[3px] ml-1">
                    {loading ? (
                      <SkeletonCard
                        type="text"
                        lines={1}
                        widths={["60px"]}
                        heights={["10px"]}
                      />
                    ) : (
                      selectedBot?.setting?.max_order_count || 0
                    )}
                    &nbsp;order
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BotOverviewDCA;
